import type { EquipmentInstance } from '../equipment/equipmentTypes';
import { equipmentProvenance } from '../../utils/equipmentGeometry';

/**
 * The equipment areas LLM route generation routes: EVERY area the user identified by hand
 * (provenance 'manual') — whether drawn before the route flow started, during marking, or after
 * an earlier generation. Shared by both entry points (the Toolbox button and the assistant chat).
 *
 * Decided by where an area came from, not by when it was drawn: an earlier "baseline" snapshot
 * taken when marking first started treated every area that already existed as pre-existing, so
 * equipment drawn before opening the route flow was silently left out. Areas extracted from the
 * DXF (provenance 'dxf') or restored from a saved layout ('layout') are never included, even if
 * accepted — only the user's own identifications drive routing.
 */
export function routeEquipmentIds(instances: Record<string, EquipmentInstance>): string[] {
  return Object.keys(instances).filter(
    (id) => instances[id] && equipmentProvenance(instances[id]) === 'manual'
  );
}
